import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiDelete, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

export const useDeleteUser = createMutationHook<{ deleted: boolean }, string>({
  mutationFn: (userId) =>
    apiDelete<{ deleted: boolean }>(operationsClient, settingsEndpoints.deleteUser(userId)),
  onSuccess: (_data, userId, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.users() });
    void queryClient.invalidateQueries({ queryKey: settingsKeys.userDetail(userId) });
    toast.success('User deleted');
  },
});
